import { initState } from "../../common/util/StateUtil";
import assign from "object-assign";
import { APPLY_CQL_FILTER } from "../action/applyCqlFilterAction";
import { CLEAR_CQL_FILTER } from "../action/clearCqlFilterAction";

const layersReducer = (initialState: any, action: any) => {
    const state = initState(initialState);
    if (action.type === APPLY_CQL_FILTER) {
        return assign({}, state, { cqlFilter: action.cqlFilter });
    }
    if (action.type === CLEAR_CQL_FILTER) {
        return assign({}, state, { cqlFilter: null });
    }
    return state;
};

export default layersReducer;
